import {
    GelLabel
} from '@tal-gel/components';
import styled from "@emotion/styled";
import { getGelTokens } from '@tal-gel/theming';

const { global: { sizeBaseX4 } } = getGelTokens()

export const StyledGelLabel = styled(GelLabel)(() => ({
    fontWeight: "400"
}));

export const Spacer = styled.div(() => ({
    paddingTop: sizeBaseX4
}));

export const formatCurrency = (value: unknown): string | null => {
    const num = Number(value);
    return (!isNaN(num) && value !== null && value !== undefined)
      ? num.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : null;
  }